<template>
  <div>
      <h2>Ignorierte Stunden</h2>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>

      <b-row class="mb-3" align-h="between">
        <b-col cols="auto"></b-col>
        <b-col cols="auto">
          <!-- <b-button variant="outline-primary" @click="navigate('Users.Addresses.Add')"><b-icon icon="plus"/> {{ $t('views.users.addresses.button.addaddress') }}</b-button> -->
        </b-col>
      </b-row>

   <div>
    <h3>Ignoriert</h3>
    <p>Nachfolgende Einträge wurden für die Abrechnung ignoriert.</p>
      <b-table striped hover :items="this.reports" :fields="fields">
        <template v-slot:cell(start)="data">
          <timeago :datetime="data.item.start" auto-update/>
          <!-- <b-form-input v-model="data.item.start" @blur="updateWorklog(data.item)" /> -->
        </template>
        <template v-slot:cell(isIgnoredForAccounting)="data">
          <b-form-checkbox v-model="data.item.isIgnoredForAccounting" @change="updateWorklog(data.item)" />
        </template>
        <template v-slot:cell(clickUpCustomTaskId)="data">
          <b-form-input v-model="data.item.clickUpCustomTaskId" @blur="updateWorklog(data.item)" />
        </template>
        <template v-slot:cell(comment)="data">
          <b-form-textarea v-model="data.item.comment" @blur="updateWorklog(data.item)" />
        </template>
        <template v-slot:cell(taskName)="data">
          <b-form-textarea v-model="data.item.taskName" @blur="updateWorklog(data.item)" />
        </template>
        <template v-slot:cell(industryTimeSpend)="data">
          <b-form-input v-model="data.item.industryTimeSpend" @blur="updateWorklog(data.item)" />
          <small>{{ formatMinutesToHoursMinutes(data.item.timeSpendInMinutes)}}</small>
        </template>
          </b-table>
          </div>
  </div>
</template>

<script>
import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'

// import { TableHelper } from '@/assets/js/helper/table'

import MixinEntityBase from '@/components/mixins/EntityBase'
// import EntityEntryTable from '@/components/entity/EntryTable'
import http from '@/$plugins/http'

const ENTITY_KEY = 'projectaccountingtasks'
const RELATION_KEY = 'accountingtasks'
const WORKLOGS_NOT_EDITABLE = 'Nicht zugeordnet'

export default {
  name: 'Projects.WorklogsIgnored',
  mixins: [MixinEntityBase],
  components: {
    // EntityEntryTable
  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      relationKey: RELATION_KEY,
      worklogsNotEditable: WORKLOGS_NOT_EDITABLE,
      loading: false,
      reports: [],
      summaryreports: [],
      emailFilter: '',
      accountableFilter: false,
      dateFilter: null,
      accountingTaskFilter: '',
      isSelectedFilter: false,
      fields: [
        { key: 'importToBexio', label: 'An Bexio senden', sortable: true },
        { key: 'isIgnoredForCostCeiling', label: 'Nicht Teil von Kostendach', sortable: true },
        { key: 'isIgnoredForAccounting', label: 'Für Abrechnung Ignorrieren', sortable: true },
        // { key: 'projectAccountingTaskId', label: 'Project Accounting Task ID' },
        { key: 'username', label: 'Benutzer', sortable: true },
        { key: 'clickUpCustomTaskId', label: 'Task-Id', sortable: true },
        { key: 'taskName', label: 'Task-Name', sortable: true },
        { key: 'comment', label: 'Kommentar', sortable: true },
        // { key: 'sentToBexioAt', label: 'An Bexio gesendet' },
        // { key: 'isDeleted', label: 'Is Deleted' },
        { key: 'start', label: 'Datum', sortable: true },
        { key: 'industryTimeSpend', label: 'Zeitaufwand', sortable: true }
      ],
      summaryreportsfields: [
        { key: 'accountingTaskName', label: 'Taskname', sortable: true },
        { key: 'hoursPrepared', label: 'Stunden', sortable: true, formatter: (value, key, item) => this.formatNumber(value), class: 'text-right' },
        { key: 'moneyPrepared', label: '$$$', sortable: true, formatter: (value, key, item) => this.formatMoney(value), class: 'text-right' },
        { key: 'remainingFromBudget', label: 'Noch abrechenbar', formatter: (value, key, item) => this.formatNumber(value), sortable: true, class: 'text-right' }
      ]
    }
  },
  computed: {
    isCurrentRoute () {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    }
  },
  methods: {
    canBePrepared (entry) {
      return entry.accountingTask.name !== this.worklogsNotEditable
    },
    formatMinutesToHoursMinutes (minutes) {
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = minutes % 60
      return `${hours}h ${remainingMinutes}m`
    },
    formatHoursToDays (value) {
      const days = Math.floor(value / 24)
      const hours = value % 24
      return `${days}d ${hours}h`
    },
    formatNumber (number) {
      if (number === null || number === undefined) return
      return number.toLocaleString('de-CH', { minimumFractionDigits: 2 })
    },
    formatMoney (amount) {
      return parseFloat(amount).toLocaleString('de-CH', {
        style: 'currency',
        currency: 'CHF'
      })
    },
    async updateWorklog (worklog) {
      try {
        const timeSpendInMinutes = Math.round(worklog.industryTimeSpend * 60)
        const endpoint = `/${STOREMODULE_ENDPOINTMODULE_MAP.business}/api/${STOREMODULE_ENDPOINT_MAP.worklogs}/${worklog.id}/updatepartial`
        const payload = {
          clickUpCustomTaskId: worklog.clickUpCustomTaskId,
          taskName: worklog.taskName,
          comment: worklog.comment,
          timeSpendInMinutes: timeSpendInMinutes,
          isIgnoredForAccounting: worklog.isIgnoredForAccounting,
          isIgnoredForCostCeiling: worklog.isIgnoredForCostCeiling,
          importToBexio: worklog.importToBexio
        }
        await http.put(endpoint, payload)
        // Handle the response or perform additional actions if needed
      } catch (error) {
        console.error(error)
      }
    },
    async loadWorklogs () {
      try {
        this.loading = true
        const response = await http.get(`/${STOREMODULE_ENDPOINTMODULE_MAP.business}/api/${STOREMODULE_ENDPOINT_MAP.worklogs}/fromproject/${this.projectId}/ignoredforaccounting`)
        this.reports = response.data

        this.reports.forEach(worklog => {
          const hours = Math.floor(worklog.timeSpendInMinutes / 60)
          const minutes = worklog.timeSpendInMinutes % 60
          worklog.industryTimeSpend = hours + minutes / 60
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    setReadyToUpload (worklog, value) {
      worklog.isReadyToUpload = value
      // Here, you would probably also want to send a request to your API to update the worklog item on the server
    }
  },
  created () {
    const urlParams = new URLSearchParams(window.location.search)
    this.currentPage = parseInt(urlParams.get('page')) || 1
    this.pageSize = parseInt(urlParams.get('pageSize')) || 50
    const urlParts = window.location.pathname.split('/')
    const projectId = urlParts[urlParts.length - 2] // Extract the second-to-last part from the URL path
    this.projectId = projectId
    this.loadWorklogs()
  }
}
</script>

<style lang="scss">
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
